import * as React from "react";
import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { blogApiService } from "@/src/lib/api-services/blogApiServices";

import BlogList from "@/src/modules/blog/blogList";
import ChipBlog from "@/src/modules/blog/chipBlog";
import BannerImage from "@/src/components/common/bannerImage";
import TaggedProduct from "@/src/components/blog/taggedProduct";

BlogDetails.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default function BlogDetails({ data }) {
    const blogDetails = data;

    return (
        <>
            <div className="bg-lightGrey">
                <BannerImage
                    image={blogDetails?.bannerImage}
                    title={blogDetails?.title || "Blog Banner"}
                />
                <div className="md:py-12 py-4 max-w-6xl mx-auto">
                    <div className="flex flex-wrap flex-row-reverse">
                        <div className="md:w-1/4 w-full md:mb-0 mb-5">
                            <p className="md:text-2xl text-xl font-bold text-black mb-4">
                                Tags
                            </p>
                            <div className="bg-white p-3 overflow-hidden rounded-xl shadow-md">
                                {blogDetails?.taggedSpecializations?.length >
                                    0 &&
                                    blogDetails?.taggedSpecializations.map(
                                        (tag, index) => (
                                            <ChipBlog key={index} tag={tag} />
                                        )
                                    )}
                            </div>
                        </div>
                        <div className="md:w-3/4 w-full md:pr-7 pr-0">
                            <div className="bg-white md:p-7 p-5 overflow-hidden rounded-xl shadow-md">
                                <h1 className="md:text-2xl text-xl text-black font-bold  md:leading-3 sm:mb-0 md:mb-0 mb-2 ">
                                    {blogDetails?.pageName}
                                </h1>
                                <p className="text-gray-500 pb-5 md:text-base text-sm">
                                    {blogDetails?.publishedOn}
                                </p>

                                <div
                                    className="text-slate-800 text-sm blog_details"
                                    dangerouslySetInnerHTML={{
                                        __html: blogDetails?.bodyHtml,
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h6 className="md:text-2xl text-xl font-bold text-black md:mt-8 mt-4 pb-4">
                            Related Products
                        </h6>
                        <TaggedProduct data={blogDetails?.taggedProducts} />
                    </div>

                    <div>
                        <h6 className="md:text-2xl text-xl md:pb-3 pb-2 font-bold text-black md:mt-8 mt-4">
                            Trending Blogs
                        </h6>

                        <div className="grid gap-6 grid-cols-3">
                            {blogDetails?.taggedPages?.length > 0 &&
                                blogDetails?.taggedPages.map((item, index) => (
                                    <BlogList key={index} item={item} />
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

// This ensures that the page is server-side rendered
export async function getServerSideProps(context) {
    const slug = context.query.slug;

    let data = null;
    // Fetching the specialization data (you can modify this as needed)
    try {
        const response = await blogApiService.blogDetailPage(slug);
        data = response?.data?.[0];
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }

    return {
        props: {
            data: { ...data, routerPath: `blog/${slug}` },
        },
    };
}
